import styles from './index.module.less'
import { LeftSelectArea } from './LeftSelectArea'
import { RightConfigArea } from './RightConfigArea'
import { useState } from 'react'
import { useUpdateEffect } from 'ahooks'
import { SBack } from 'shj-components'
import { Button, Spin } from 'antd'
import { useParams, useSearchParams } from 'react-router-dom'

const SelectingMaterials = () => {
  const params = useParams()
  const type = params.type || 'PROJECT'
  console.log(params, 'params')
  const [selectMaterialObj, setSelectMaterialObj] = useState<any>({}) // 左侧选择的数据
  const [currentSearchParams, setCurrentSearchParams] = useState<any>({}) //设置当前参数
  const [fullLoading, setFullLoading] = useState(false) // 全局loading
  const [deleteMaterialObj, setDeleteMaterialObj] = useState<any>({}) // 删除的当前物料
  useUpdateEffect(() => {}, [selectMaterialObj])
  const title = {
    ADD: '新增增项',
    SUB: '新增减项',
    PROJECT: '新增选材',
    GENERAL: '新增通项选材',
  }
  const clickToFullScreen = () => {
    const boxNode: any = document.querySelector('.spin-wrapper')
    console.log(boxNode, 'boxNode')
    boxNode.classList.toggle('full-screen')
  }
  return (
    <>
      <Spin spinning={fullLoading} wrapperClassName={'spin-wrapper'}>
        <SBack
          level={4}
          title={title[type]}
          extra={[
            <Button type="primary" onClick={clickToFullScreen}>
              全屏
            </Button>,
          ]}
        >
          <div className={styles.container}>
            <div className={styles.leftBox}>
              {/* 左侧选择物料区域 */}
              <LeftSelectArea
                selectMaterialObj={selectMaterialObj}
                setSelectMaterialObj={data => {
                  setSelectMaterialObj({ ...data })
                }}
                setCurrentSearchParams={(value: any) => setCurrentSearchParams(value)}
                deleteMaterialObj={deleteMaterialObj}
              />
            </div>
            <div className={styles.rightBox}>
              {/* 右侧具体选材添加区域 */}
              <RightConfigArea
                selectMaterialObj={selectMaterialObj}
                currentSearchParams={currentSearchParams}
                setFullLoading={v => {
                  setFullLoading(v)
                }}
                setDeleteMaterialObj={data => {
                  setDeleteMaterialObj({ ...data })
                }}
              />
            </div>
          </div>
        </SBack>
      </Spin>
    </>
  )
}

export default SelectingMaterials
